export const METIME_URL =
  process.env.VUE_APP_METIME_URL || "https://metime.com/";
export const METIME_ADMIN_PROVIDER_URL =
  process.env.VUE_APP_METIME_ADMIN_PROVIDER_URL || "http://localhost:8081";
export const METIME_SUPER_ADMIN_PROVIDER_URL =
  process.env.VUE_APP_METIME_SUPER_ADMIN_PROVIDER_URL ||
  "http://localhost:8082";

export const GOOGLE_REDIRECT_URL =
  process.env.VUE_APP_GOOGLE_AUTH_REDIRECT_URL ||
  "https://api-gateway.metime.com/api/login/oauth2/code/google";

export const TURNSTILE_SITE_KEY =
  process.env.VUE_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAD7xDKewcCkJ0avU";

export const INVALID_AUTH_FIELDS = "Invalid email or password.";
export const UNATHORIZED_CODE = 401;

export const GOOGLE_PLAY_ID = "com.codecoda.metime";
export const APP_STORE_ID = "1512803915";
export const GOOGLE_PLAY_LINK = `https://play.google.com/store/apps/details?id=${GOOGLE_PLAY_ID}&hl=en&gl=US`;
export const APP_STORE_LINK = `https://apps.apple.com/app/metime/id${APP_STORE_ID}`;

export const ROUTES = new Map([
  ["LOGIN", { name: "Login", path: "/" }],
  ["SIGN_UP", { name: "SignUp", path: "/signup" }],
  ["SIGN_UP_SUCCESS", { name: "SignUpSuccess", path: "/success" }],
  ["FORGOT_PASSWORD", { name: "ForgotPassword", path: "/forgot-password" }],
  ["RESET_PASSWORD", { name: "ResetPassword", path: "/reset-password" }],
  ["EXTERNAL_AUTH", { name: "ExternalAuth", path: "/external-auth" }],
  ["NOT_FOUND", { name: "NotFound", path: "/:catchAll(.*)" }],
]);
